var _foreignObject, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderbird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45 45h260v260H45z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 73h204v204H73z",
    style: {
      fill: "#7f3c32"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.266 168.362V83.779l73.087-42.197v84.583z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.244 141.967V92.828l42.847-24.738v49.139z",
    style: {
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.303 168.362V83.779L98.216 41.582v84.583z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.325 141.967V92.828L113.478 68.09v49.139z",
    style: {
      fill: "#fff"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m95.087 132.931 73 42-73 42-73-42z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m52.757 174.932 42.33-25.541 42.328 25.536-42.328 25.545z",
    style: {
      fill: "#fff"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m254.913 132.931 73 42-73 42-73-42z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m212.582 174.932 42.331-25.541 42.328 25.536-42.328 25.545z",
    style: {
      fill: "#fff"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.303 182.638v84.583l-73.087 42.197v-84.583z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.325 209.033v49.139l-42.847 24.738v-49.139z",
    style: {
      fill: "#fff"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.266 182.638v84.583l73.087 42.197v-84.583z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.244 209.033v49.139l42.847 24.738v-49.139z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.284,
    cy: 231.24,
    r: 10.807,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.284,
    cy: 118.623,
    r: 10.807,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.284,
    cy: 174.931,
    r: 10.807,
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderbird);
export default __webpack_public_path__ + "static/media/thunderbird.159435d367e0eb4f817f2261497ffb4a.svg";
export { ForwardRef as ReactComponent };